import { streamlineBracketLabel } from "./adapter";
const COMPLETED_PREFIX = "completed:";
/** An added card as an entry, keyed apart from the solver's entries. */
export const completedEntry = (option, points, index, added = false) => ({
    player: option.player,
    position: option.position,
    price: option.price,
    source: option.source,
    untradeable: option.untradeable,
    eaPlayerId: option.eaPlayerId,
    entryId: `${COMPLETED_PREFIX}${index}`,
    points,
    added,
});
/** Re-keys `entries` as the added cards 0..n; the order and the flag are kept. */
export const asCompleted = (entries) => entries.map((entry, index) => completedEntry(entry, entry.points, index, entry.added ?? false));
/** The marks the added cards start with: every one of them. */
export const completedMarks = (completed) => Object.fromEntries(completed.map((entry) => [entry.entryId, true]));
export const completedPoints = (completed) => completed.reduce((sum, entry) => sum + entry.points, 0);
/** The physical club cards among the added ones; what the next solve must not place again. */
export const completedEaPlayerIds = (completed) => completed
    .map((entry) => entry.eaPlayerId)
    .filter((id) => id !== undefined);
/**
 * The solution with the added cards folded into their rating's row, added
 * cards first; a rating the solver did not use gets a row of its own. Rows
 * are by points descending, whichever kind they are. Aggregates are
 * recomputed so the header counts the added cards too.
 */
export const withCompleted = (solution, completed) => {
    if (completed.length === 0)
        return solution;
    const byRating = new Map();
    for (const entry of completed) {
        const rating = entry.player.rating;
        byRating.set(rating, [...(byRating.get(rating) ?? []), entry]);
    }
    const brackets = solution.brackets.map((bracket) => {
        const added = byRating.get(bracket.rating);
        if (!added)
            return bracket;
        byRating.delete(bracket.rating);
        return { ...bracket, players: [...added, ...bracket.players] };
    });
    for (const [rating, added] of byRating) {
        const first = added[0];
        if (!first)
            continue;
        brackets.push({
            bracketId: `${COMPLETED_PREFIX}${rating}`,
            points: first.points,
            label: streamlineBracketLabel({ cls: "base", rating }, first.player.metalId),
            rating,
            players: added,
        });
    }
    brackets.sort((a, b) => b.points - a.points);
    const entries = brackets.flatMap((bracket) => bracket.players);
    const market = entries.filter((entry) => entry.source === "MARKET");
    return {
        ...solution,
        brackets,
        totalValue: entries.reduce((sum, entry) => sum + entry.price, 0),
        transferCost: market.reduce((sum, entry) => sum + entry.price, 0),
        transferCount: market.length,
        ownedCount: entries.length - market.length,
    };
};
//# sourceMappingURL=completed.js.map